import { Row, Col, message } from "antd";
import { useState, useEffect } from "react";
import { LoginForm } from "./form";
import { TwoFAForm } from "./2FA";
import {SecurePassForm} from "./SecurePass";
import { LoginHeading } from "./heading";
import { Authenticate, Verify2FACode, useDeviceInfo, useIpAddress, recoveryPhone, Guardar_numero, updateUserPassword } from "../../../helpers/auth/login";
import { StyledContainer } from "./login-styled-components";
import PhoneNumberModal from "../../../helpers/auth/phoneNumberModal";
import { auth, RecaptchaVerifier, signOut } from "../../../helpers/auth/index";
import nookies from "nookies"; 
import { multiFactor,PhoneAuthProvider, PhoneMultiFactorGenerator } from "firebase/auth";
import { useRouter } from 'next/router';
import EnableTotp from "./enableTotp";
import TotpForm from "./TOTP/totpForm";
import { VerifyTotpCode } from "../../../helpers/auth/login";

export function LoginContainer() {
  const router = useRouter();
  const [is2FA, setIs2FA] = useState(false);
  const [recaptchaVerifier, setRecaptchaVerifier] = useState(null);
  const [info, setInfo] = useState({});
  const [ipInfo, setIpInfo] = useState({});
  const [userID, setID] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [recovery, setrecovery] = useState(true);
  const [emailNotVerified, setEmailNotVerified]= useState(false);
  const [securePass, setSecurePass] = useState(false);
  const [verificationId, setVerificationId] = useState(null);
  const [isWaitingCode, setIsWaitingCode] = useState(false);
  const [factorType, setFactorType] = useState(null);
  const [showTotpSetup, setShowTotpSetup] = useState(false)
  const [multipleFactors, setMultipleFactors] = useState(null);
  const [factorChoiceVisible, setFactorChoiceVisible] = useState(false)
  const [authResolver, setAuthResolver] = useState(null)
  const deviceInfo = useDeviceInfo();
  const location = useIpAddress();

  const handleBeforeUnload = (event) => {
     
      event.preventDefault();
      
    };

    const handleLogoutOnExit = () => {
        sessionStorage.setItem('logout_in_progress', 'true');
        signOut(auth)
        nookies.destroy(null, "token", { path: "/" })
        nookies.destroy(null, "2FAToken", { path: "/" })
        localStorage.clear();
    };
  useEffect(() => {
    
    const cookies = nookies.get(null);

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleLogoutOnExit);
    
    Object.keys(cookies).forEach((cookieName) => {
  
      if (cookieName.startsWith("primaryDeviceId_")) return;

      nookies.destroy(null, cookieName, { path: "/" });
    });

    if ("caches" in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }

    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
    }

    auth.useDeviceLanguage();

    if (!window.recaptchaVerifier) {
      const el = document.getElementById("recaptcha-container");
      if (el) {
        const verifier = new RecaptchaVerifier(
          el,
          { size: "invisible" },
          auth
        );
        window.recaptchaVerifier = verifier;
        setRecaptchaVerifier(verifier);
      }
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleLogoutOnExit);
    };
  }, []);

  useEffect(() => {
    if (location && deviceInfo) {
      setIpInfo({ ...location, ...deviceInfo });
    }
  }, [location, deviceInfo]);

  const onFinish = async ({ email, password }) => {
    setInfo({ email: email, pass: password });
    setIpInfo({ ...ipInfo, email: email });
    const result = await Authenticate(email, password, recaptchaVerifier);;
    if(result?.userApp){
      message.error("Error: Usuario sin permiso de acceso");
    }
    if(result?.emailNotVerified){
      setEmailNotVerified(true)
    }

    if (result?.multipleFactors) {
      setMultipleFactors(result.hints);
      setAuthResolver(result.resolver);
      setFactorChoiceVisible(true);
      setInfo({ email: result.email, pass: result.password });
    } else if (result?.twoFARequired) {
      setIs2FA(true);
      setFactorType(result.type);
      setID(result?.uid);
      setVerificationId(result);
    } else if (result?.NophoneNumber) {
      setModalVisible(true);
      setrecovery(false);
      setID(result?.uid);
    }
   
  }

  const handleFactorSelection = async (selectedHint) => {
    setFactorChoiceVisible(false);

    if (selectedHint.factorId === 'totp') {
      setIs2FA(true);
      setFactorType('totp');
      setVerificationId({
        type: 'totp',
        resolver: authResolver,
        hint: selectedHint
      });
    } else if (selectedHint.factorId === 'phone') {
      setIs2FA(true)
      setFactorType('sms')
      try {
        const phoneAuthProvider = new PhoneAuthProvider(auth);
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          {
            multiFactorHint: selectedHint,
            session: authResolver.session
          },
          recaptchaVerifier
        );

        setIs2FA(true);
        setFactorType('sms');
        setVerificationId({
          type: 'sms',
          verificationId,
          resolver: authResolver,
          phone: selectedHint.phoneNumber
        });
      } catch (error) {
        console.error("Error al enviar SMS:", error);
        message.error("Error al enviar el código SMS");
      }
    }
  };


  const handleNewPhone = async (phone) => {
    setModalVisible(false);
    const result = await Guardar_numero(userID, phone, recaptchaVerifier);

    if (result?.twoFARequired) {
      setIs2FA(true);
      setID(result?.uid);
    }
  };

  const onSubmitCode = async ({ code }) => {
    const result = await Verify2FACode(code, setIs2FA, info.email, info.pass, ipInfo, verificationId);

    if(result?.enableTotp){
      setShowTotpSetup(true)
      return
    }
    
    if(result?.NoSecurePass){
     
      setSecurePass(true)
      setIs2FA(false);
   
    }else{
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleLogoutOnExit);

      const destination =  result?.role !== "ADMIN_AUDITOR" ? "/admin/submissions" : "/dashboards/submissions";
      router.push(destination);
    }
  };

  const onSubmitPass = async ({pass}) =>{
    const result =  await updateUserPassword(pass)

    if(result){
      setIs2FA(false)
      setSecurePass(false)
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleChangePhoneNumberSubmit = async (phone) => {
    setModalVisible(false)

    const result = await recoveryPhone(phone)

    if (result.status && result.id) {
    setVerificationId(result.id)
    setIsWaitingCode(true)
    setModalVisible(true)
  }
  }

  const handleCodeSubmit = async (code) => {
    setModalVisible(false);
    const user = auth.currentUser;

    if (!user || !verificationId) {
      message.error("Falta información para verificar el teléfono.");
      return;
    }

    try {
      const cred = PhoneAuthProvider.credential(verificationId, code);
      const assertion = PhoneMultiFactorGenerator.assertion(cred);
      await multiFactor(user).enroll(assertion, 'Teléfono de recuperación');
      message.success("Teléfono guardado correctamente.");
      setIsWaitingCode(false)
    } catch (error) {
      console.error("Error al guardar el teléfono:", error);
      message.error(error.message || "Código inválido o expirado.")
      setModalVisible(true)
    }
  }

  const sizeProps = {
    xs: 16,
    sm: 16,
    md: 8,
    lg: 5,
  }
  const onSubmitTotp = async ({ code }) => {
    const result = await VerifyTotpCode(
      code,
      setIs2FA,
      ipInfo,
      verificationId.resolver
    );
  
    if (result?.NoSecurePass) {
      setSecurePass(true);
      setIs2FA(false);
      return
    }

    window.removeEventListener('beforeunload', handleBeforeUnload)
    window.removeEventListener('unload', handleLogoutOnExit)
  
    const destination =
      result?.role !== "ADMIN_AUDITOR"
        ? "/admin/submissions"
        : "/dashboards/submissions"
  
    window.location.href = destination
  }
  
  return (
    <StyledContainer>
      <Row className="login__Row--fullHeight" align="middle" justify="center">
        <Col {...sizeProps}>
          <LoginHeading 
            twoFA={is2FA} 
            emailNotVerified={emailNotVerified} 
            phoneNumber={verificationId?.phone} 
            securePass ={securePass} 
            multipleFactors={factorChoiceVisible}
            selectedFactor={factorType}/>
           {!is2FA && !securePass && (
            <LoginForm 
              onSubmit={onFinish}
              multipleFactors={multipleFactors}
              onFactorSelect={handleFactorSelection}
              showFactorChoice={factorChoiceVisible}
            />
          )}
          {securePass && <SecurePassForm onSubmitPass={onSubmitPass} /> }
          {is2FA && factorType === "sms" && (
          <TwoFAForm
            onSubmitCode={onSubmitCode}
            onChangePhone={() => setModalVisible(true)}/>
            )}
            {is2FA && factorType === "totp" && (
          <TotpForm
          onSubmitCode={onSubmitTotp} /> )}
        </Col>
      </Row>
     {showTotpSetup && (
    <div 
      className="totp-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >
    <div style={{
      background: 'white',
      padding: '30px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      maxWidth: '500px',
      width: '90%'
    }}>
     <EnableTotp
        onComplete={() => {
          setShowTotpSetup(false);
          signOut(auth).then(() => {
            router.push('/')
          })
        }}
      />
    </div>
  </div>
)}

      <div id="recaptcha-container"></div>
      <PhoneNumberModal
        visible={modalVisible}
        onOk={handleChangePhoneNumberSubmit}
        onCancel={handleModalCancel}
        recovery={recovery}
        onOkNewPhone={handleNewPhone}
        recoveryCode={isWaitingCode}
        onNewPhoneCode={handleCodeSubmit}
      />
    </StyledContainer>
  );
}